export default __webpack_public_path__ + "img/bg-login-page.1834ef82.svg";